import { createAction } from 'redux-actions';

export const loadAllStates = createAction('LOAD_ALL_STATES');
export const loadAllStatesTranslate = createAction('LOAD_ALL_STATES_TRANSLATE');
export const filterStates = createAction('FILTER_STATES');
export const paginateStates = createAction('PAGINATE_STATES');
export const changeSortConfigState = createAction('CHANGE_SORT_CONFIG_STATE');
